export enum IssueType {
    NoHeartbeatReceived = 10001,
    NoImageFromCamera = 11002, // Eos connection loss
    NoImageReceived = 11005, // Image upload status

    SystemFailure = 41100,
    ConnectionFailure = 41200,
    VideoQualityFailure = 41300,
    Tampering = 41500,
    ConnectionDegraded = 42200,
}
